export default __webpack_public_path__ + "static/media/books-69.ccd2d5bd.jpg";